import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { CvEntryNodeView } from "@/components/editor/nodeviews/CvEntryNodeView";

/**
 * Single CV entry — a job, degree, project, etc. Period sits on the
 * right via \hfill; role + org on the left in bold; description as a
 * normal paragraph below. Tech tags are an optional bullet line.
 */
export const CvEntryBlock = Node.create({
  name: "cvEntryBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      period: { default: "" },
      role: { default: "" },
      org: { default: "" },
      location: { default: "" },
      highlight: { default: "" },
      description: { default: "" },
      tech: { default: [] as string[] },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="cv-entry-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "cv-entry-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CvEntryNodeView);
  },
});
